$(document).ready(function () {
  // Accordion
  $(".accordion").on("click", ".acc-title", function () {
    $(this).toggleClass("active").siblings(".acc-content").slideToggle();
    $(this)
      .parents(".accordion")
      .find(".acc-title")
      .not(this)
      .removeClass("active")
      .siblings(".acc-content")
      .slideUp();
  });
  $(".page-engagement-rings .accordion .acc-title").addClass("active");

  // Tabs
  $(
    ".tabs .tabs-nav li:first-child, .tabs .tabs-content-wrapper .tab-content:first-child"
  ).addClass("active");
  $(".tabs .tabs-nav li").on("click", function () {
    let dataTab = $(this).attr("data-tab");
    $(this).addClass("active").siblings().removeClass("active");
    $('[data-id="' + dataTab + '"]')
      .addClass("active")
      .siblings()
      .removeClass("active");
  });

  // Main Slider
  const home_main_slider = $(".home-main-slider");
  if (home_main_slider.length) {
    home_main_slider.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
      arrows: false,
      adaptiveHeight: true,
      autoplay: true,
      autoplaySpeed: 5000,
      pauseOnFocus: false,
    });
  }

  // Reviews Slider
  let reviewSlider = $(".reviews-slider");
  if (reviewSlider.length) {
    reviewSlider.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
      arrows: true,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            arrows: false,
          },
        },
      ],
    });
  }
  let googleReviewSlider = $(".google-reviews-slider");
  if (googleReviewSlider.length) {
    googleReviewSlider.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: false,
      arrows: true,
      adaptiveHeight: true,
    });
  }

  // center columns section
  if ($(window).width() < 750) {
    const center_columns_slider = $(".center-columns-slider");
    if (center_columns_slider.length) {
      center_columns_slider.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        arrows: false,
        adaptiveHeight: true,
        infinite: false,
      });
    }
  }

  // Collection section slider
  let gridViewItemSlider = $(".product-grid-slider .grid--view-items");
  if (gridViewItemSlider.length) {
    gridViewItemSlider.slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      infinite: true,
      autoplay: false,
      adaptiveHeight: true,
      autoplaySpeed: 3000,
      speed: 500,
      rows: 0,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });
  }

  // Page - Diamonds
  // browse collection
  if ($(window).width() < 750) {
    const diamond_collection_slider = $(".diamonds-collection-slider");
    if (diamond_collection_slider.length) {
      diamond_collection_slider.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
      });
    }
  }

  // Page - Wedding Band Education
  let weddingBandEduSlider = $(".wedding-band-education-slider");
  if (weddingBandEduSlider.length) {
    weddingBandEduSlider.slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      dots: false,
      arrows: true,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 3,
          },
        },
        {
          breakpoint: 750,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    });
  }

  let tabsheadingSlider = $(".tabs-heading-slider");
  if (tabsheadingSlider.length) {
    tabsheadingSlider.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: false,
      arrows: true,
      asNavFor: ".tabs-content-slider",
    });
  }
  let tabsContentSlider = $(".tabs-content-slider");
  if (tabsContentSlider.length) {
    tabsContentSlider.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: false,
      arrows: false,
      asNavFor: ".tabs-heading-slider",
    });
  }

  let tabs_ContentSlider = $(".tabs_content-slider");
  let tabs_contentSliderOptions = {
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    arrows: true,
  };
  if (tabs_ContentSlider.length) {
    tabs_ContentSlider.slick(tabs_contentSliderOptions);
  }
  $(".slider-inside-tabs .tabs .tabs-nav li").on("click", function () {
    tabs_ContentSlider.slick("unslick");
    tabs_ContentSlider.slick(tabs_contentSliderOptions);
  });

  // Wedding - Choose metal
  let chooseMetal = $(".choose-metal .acc-title");
  chooseMetal.on("click", function () {
    let dataTitle = $(this).attr("data-title");
    $('.choose-metal [data-id="' + dataTitle + '"]')
      .addClass("scale-it")
      .siblings()
      .removeClass("scale-it");
  });

  // Page - Our Jewelry
  let jewelryCatalogSlider = $(".jewelry-catalog-slider");
  if ($(window).width() < 750) {
    if (jewelryCatalogSlider.length) {
      jewelryCatalogSlider.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        arrows: true,
      });
    }
  }

  let textColumnSlider = $(".text-columns-slider");
  if (textColumnSlider.length) {
    textColumnSlider.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: false,
      arrows: true,
    });
  }
  // Multi Slider
  var numSlick = 0;
  $(".multi-slider").each(function () {
    numSlick++;
    let $multiTitleSlider = $(this)
      .find(".multi-title-slider")
      .addClass("slider-" + numSlick);
    let $multiContentSlider = $(this)
      .find(".multi-content-slider")
      .addClass("slider-" + numSlick);
    let slideNum = $multiTitleSlider.find(".slide").length;
    if (slideNum > 6 || $(window).width() < 750) {
      $multiTitleSlider.slick({
        vertical: false,
        slidesToShow: 6,
        slidesToScroll: 1,
        dots: false,
        arrows: true,
        draggable: false,
        focusOnSelect: true,
        asNavFor: ".multi-content-slider.slider-" + numSlick,
        responsive: [
          {
            breakpoint: 750,
            settings: {
              slidesToShow: 1,
            },
          },
        ],
      });
    }

    $multiContentSlider.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: false,
      arrows: false,
      adaptiveHeight: true,
    });
    if ($multiTitleSlider.hasClass("slick-slider")) {
      $multiContentSlider.slick(
        "slickSetOption",
        "asNavFor",
        ".multi-title-slider.slider-" + numSlick,
        true
      );
    }

    $multiTitleSlider.find("div[data-slide]").on("click", function () {
      $(this).addClass("active").siblings().removeClass("active");
      var slideno = $(this).data("slide");
      $multiContentSlider.slick("slickGoTo", slideno - 1);
    });
    $multiContentSlider.on(
      "afterChange",
      function (event, slick, currentSlide) {
        console.log(currentSlide);
        var index = currentSlide + 1;
        $multiTitleSlider.find(".slide").removeClass("active");
        $multiTitleSlider.find(".slide.slide_" + index).addClass("active");
      }
    );

    // V1
    let $this = $(this);
    if ($this.parents().hasClass("multi-slider-v1")) {
      console.log("This works!!");
      if (
        (slideNum < 9 && $(window).width() > 750) ||
        (slideNum < 3 && $(window).width() < 750)
      ) {
        $multiTitleSlider.slick("unslick");
      } else {
        $multiTitleSlider.slick(
          "slickSetOption",
          {
            slidesToShow: 8,
            variableWidth: true,
            responsive: [
              {
                breakpoint: 750,
                settings: {
                  slidesToShow: 2,
                },
              },
            ],
          },
          true
        );
      }
    }
  });

  // Tabs hover slider
  $(".tabs-hover-slider").each(function () {
    let $tabsIconSlider = $(".tab-icons-slider");
    let $tabsContentSlider = $(".tab-content-slider");

    if ($(window).width() < 750) {
      $tabsIconSlider.slick({
        slidesToShow: 5,
        slidesToScroll: 1,
        dots: false,
        arrows: false,
        draggable: false,
        focusOnSelect: true,
        infinite: false,
        asNavFor: ".tab-content-slider",
        responsive: [
          {
            breakpoint: 750,
            settings: {
              slidesToShow: 1,
              infinite: true,
              fade: true,
              cssEase: "linear",
            },
          },
        ],
      });
    }

    $tabsContentSlider.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: false,
      arrows: false,
      infinite: false,
      fade: true,
      cssEase: "linear",
      draggable: false,
      speed: 100,
      responsive: [
        {
          breakpoint: 750,
          settings: {
            draggable: true,
            infinite: true,
            asNavFor: ".tab-icons-slider",
            dots: true,
          },
        },
      ],
    });

    $(".tab-icons-slider .tab-icon").on("mouseover", function () {
      $(this).addClass("slick-current").siblings().removeClass("slick-current");
      $tabsContentSlider.slick("slickGoTo", $(this).index());
    });
  });

  // Video play/pause functionality
  $(".video-box .video-pre-icon #play").on("click", function () {
    $(this).closest(".video-box").find("video").trigger("play");
    $(this).closest(".video-box").find(".video-poster").hide();
    $(this).closest(".video-box").find(".video-content").hide();
    $(this).closest(".video-box").find(".video-pre-icon #stop").show();
    $(this).hide();
  });
  $(".video-box .video-pre-icon #stop").on("click", function () {
    $(this).closest(".video-box").find("video").trigger("pause");
    $(this).closest(".video-box").find(".video-pre-icon #play").show();
    $(this).hide();
  });
  $(".video-box video").on("ended", function () {
    $(this).closest(".video-box").find(".video-poster").show();
    $(this).closest(".video-box").find(".video-content").show();
    $(this).closest(".video-box").find(".video-pre-icon #play").show();
    $(this).closest(".video-box").find(".video-pre-icon #stop").hide();
  });

  // Blog page
  const article_slider = $(".featured-articles-slider");
  if (article_slider.length) {
    $(".featured-articles-slider").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: false,
      arrows: true,
    });
  }

  // Home preview page
  const custom_ring_slider = $(".customize-ring-slider");
  if (custom_ring_slider.length) {
    $(".customize-ring-slider").slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      dots: false,
      arrows: true,
      responsive: [
        {
          breakpoint: 750,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    });
  }

  // Home - Customer reviews
  const home_customer_slider = $(".home-customer__slider");
  if (home_customer_slider.length) {
    $(".home-customer__slider").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
      arrows: false,
      adaptiveHeight: true,
      // responsive: [
      //   {
      //     breakpoint: 1025,
      //     settings: {
      //       slidesToShow: 3,
      //     },
      //   },
      //   {
      //     breakpoint: 750,
      //     settings: {
      //       slidesToShow: 1,
      //     },
      //   },
      // ],
    });
  }

  // Page - Our policies
  const policy_heading_slider = $(".policy-heading-slider");
  if (policy_heading_slider.length) {
    $(".policy-heading-slider").slick({
      slidesToShow: 6,
      slidesToScroll: 1,
      dots: false,
      arrows: true,
      responsive: [
        {
          breakpoint: 1025,
          settings: {
            slidesToShow: 4,
          },
        },
        {
          breakpoint: 750,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    });
  }

  // PDP - Product features
  const product_feature_slider = $(".product-features-slider");
  if (product_feature_slider.length) {
    $(".product-features-slider").slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      dots: false,
      arrows: true,
      responsive: [
        {
          breakpoint: 990,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 750,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    });
  }
  // Page - Monthly payment option
  $(".payment-nav a").on("click", function (e) {
    e.preventDefault();
    let pay_id = $(this).attr("href");
    $(this).addClass("active").siblings().removeClass("active");
    $(pay_id).show().siblings().hide();
  });

  if ($(window).width() < 750) {
    // Icon text columns
    const icon_text_slider = $(".icon-text-columns-slider");
    if (icon_text_slider.length) {
      $(".icon-text-columns-slider").slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        arrows: true,
        adaptiveHeight: true,
      });
    }
    // const diamond_grid = $(".diamonds-grids");
    // if (diamond_grid.length) {
    //   $(".diamonds-grids").slick({
    //     slidesToShow: 1,
    //     slidesToScroll: 1,
    //     dots: false,
    //     arrows: true,
    //     adaptiveHeight: true,
    //   });
    // }

    $(".feature-column-content-slider").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
      arrows: false,
      adaptiveHeight: true,
      infinite: false,
    });
  }

  // Page navigation
  $(".page-navigation").each(function () {
    let activeLink = $(this).find("li.active");
    $(activeLink).on("click", function () {
      $(this).siblings().toggle();
      $(this).toggleClass("open-nav");
    });
  });
  // Google client
  try {
    const googleClientId = Cookies.get("_ga");
    console.log(googleClientId);
    const split_id = googleClientId.split(".");
    $(".google-client-id").text(`${split_id[2]}.${split_id[3]}`);
  } catch (e) {
    console.log(e);
  }
  // freshDesk popup on chat click
  // $(".help-grids .button-chat").on("click", function () {
  //   console.log(1);
  //   FreshworksWidget("open");
  // });
  // Customize engagement rings popup
  $("#custom-design-request").on("click", function () {
    console.log("test");
    theme.open_popup($("#custom-design-request-popup"));
  });
  $("#design-custom-ring").on("click", function () {
    theme.open_popup($("#custom-design-request-popup"));
  });
  $("#custom-design-request-popup .close-button").on("click", function () {
    theme.close_popup();
  });

  // Diamond event banner popup
  $(".banner-spend-more-get-more .know-more").on("click", function () {
    $("#diamond-event-popup").show();
  });
  $("#diamond-event-popup .close-popup,#diamond-event-popup .popup_overlay").on(
    "click",
    function () {
      $("#diamond-event-popup").hide();
    }
  );
  // Back to top - Js
  var btn = $('.back-to-top');
  $(window).scroll(function() {
    if ($(window).scrollTop() > 1200) {
      btn.show();
    } else {
      btn.hide();
    }
  });
  btn.on('click', function(e) {
    e.preventDefault();
    $('html, body').animate({scrollTop:0}, '300');
  });
  // show popup on more info click
  $(document).on(
    "click",
    ".product-infromation .more-info-icon",
    function () {
      $("body").addClass("show-website-popup");
      $("#more-info-icon-popup").addClass("show-popup-content");
    }
  );
});
